"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DriverGroups = function () {
  function DriverGroups($q, API) {
    _classCallCheck(this, DriverGroups);

    this.$q = $q;
    this.API = API;
  }

  _createClass(DriverGroups, [{
    key: "getDriverGroups",
    value: function getDriverGroups(driverIds, groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var deferred = this.$q.defer();
      var url = "v1/driver-groups";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      // todo: group id and driver id arrays are not currently implemented yet on the server side.
      // todo: leave these here as placeholders for when they do get put in
      param.push.apply(param, this.API.getArrayQuery("driverId", driverIds));
      param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));

      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (drivers) {
        //console.log("drivers groups: ", drivers);
        deferred.resolve(drivers);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getById",
    value: function getById(groupId) {
      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var deferred = this.$q.defer();
      var url = "v1/driver-groups/" + groupId;

      var param = [];
      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicle) {
        return deferred.resolve(vehicle);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return DriverGroups;
}();

exports.default = DriverGroups;


DriverGroups.$inject = ["$q", "FleetPortalAPI"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.driver-groups.js